import axios from "axios"
import type { IContactRequest } from "./contact.model"

export const contactForm = async (url: string, data: IContactRequest): Promise<void> => {
  const payload: IContactRequest = data
  const response = await axios.post<void>(url, payload)

  return response.data
}
